"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const theme_1 = require("./theme");
const ThemeProvider = ({ children }) => ((0, jsx_runtime_1.jsx)(material_1.ThemeProvider, { theme: theme_1.theme, children: children }));
exports.ThemeProvider = ThemeProvider;
